import Icon from 'components/atoms/icon/Icon';

import Input from 'components/atoms/input/Input';
import { IconType } from 'lib/helpers/constants/iconTypes';
import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props {
    control: any;
    errors: any;
    fields: any;
    append: any;
    setValue: any;
}

const Step2ProductNameAndFiles: FC<Props> = ({ control, errors, fields, append }) => {

    const { t } = useTranslation();

    return (
        <div className="rounded-[20px] bg-[#F6FBFE] p-4">
            <div className="grid grid-cols-1 gap-4">
                {fields.map((field: any, index: number) => (
                    <React.Fragment key={field.id}>
                        {/* Product Name Input */}
                        <Controller
                            name={`products.${index}.product_name`}
                            rules={{ required: t('This field is required') }}
                            control={control}
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    label="Product Name"
                                    placeholder={t('Enter')}
                                    error={errors.products?.[index]?.product_name}
                                />
                            )}
                        />

                        
                    </React.Fragment>
                ))}

                {/* Add New Product */}
                <div className="flex justify-end">
                    <div
                        className="flex items-center gap-2 cursor-pointer pt-4"
                        onClick={() => append({ product_name: '' })}
                    >
                        <Icon iconType={IconType.PLUS_ICON} color="var(--theme)" />
                        <span className="text-sm font-inter-medium text-theme">
                            {t('New Product')}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Step2ProductNameAndFiles;
